export default "__VITE_ASSET__DRk9Cn_j__"